import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

import type { ComparableField, DiffSearchMode } from '../types/diffing'
import type { TemplateVersion } from '../types/templateModel'

type TemplateContextProps = {
  viewingDetails: Optional<ComparableField>
  detailsPath: Optional<string>
  isDraftTemplate: boolean
  templateVersion: Optional<TemplateVersion>
  previousTemplateVersion: Optional<TemplateVersion>
  onChangePreviousTemplateVersionOperationKey: (
    nextVersion: Optional<string>,
  ) => void
  isDiffingAgainstShadowedVersion: boolean
  referencedVersions: Record<string, TemplateVersion>
  fieldValueForPath: <T extends ComparableField>(
    path: string,
    searchMode: DiffSearchMode,
  ) => Optional<T>
  isMappingsTemplate: boolean
  onToggleTemplatePath: (path: string) => void
  isPathCollapsed: (path: string) => boolean
  onUpdateScrollPath: (path: string) => void
  getScrollPath: () => Optional<string>
}

const [useTemplateContext, Provider] =
  createRequiredContext<TemplateContextProps>('Template')

export { Provider, useTemplateContext }
